export const ACTIVE_FILTER_PREFIX = 'filtre';
export const ACTIVE_FILTER_SUFFIX = 'actif';
export const ERROR_BUTTON_RELOAD_LABEL = 'Rééssayer';
export const ERROR_HAPPENED_TEXT = 'Une erreur est survenue';
export const NO_RESULT_TEXT = 'Aucun résultat';
